import React, { Component } from 'react';
import topMember from '../../assets/top-member.jpg';

import { NewsList } from './NewsList';


export class Top extends Component {
  render() {
    const videoStyle = {
      padding: '10px',
      'fontSize': '0.9rem',
      'color': '#666'
    };
    const MarginBottom = {
      'marginBottom': '10px'
    };

    return (
      <div className="content">
        <div id='top-image-container'>
          <img src={topMember} alt="緑フラウエンコール" id='top-midori-image'/>
          <div id='top-midori-desc'>
            緑フラウエンコールは、松村努先生のご指導のもと、横浜市青葉区を中心として活動している女声合唱団です。
          </div>
        </div>
        <div className='top-info-container'>
          <NewsList/>
        </div>
        <div>
          <div style={videoStyle}>
            <div style={MarginBottom}>
            信長貴富先生に編曲を委嘱した「さとうきび畑」です。ぜひ、聴いてみてください。
            </div>
            <iframe 
              width="200"
              height="112.5"
              src="https://www.youtube.com/embed/su41TgRWN8E?si=EtONf6Ndw8nX7w37"
              title="さとうきび畑（信長貴富：編曲　女声合唱版）緑フラウエンコール"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
          </div>
          <div style={videoStyle}>
            <div style={MarginBottom}>
            女声合唱とピアノのための小品集〈ポケットの星〉より 「麦わら帽子」  (作曲: 沼尻竜典)
            </div>
            <iframe 
              width="200"
              height="112.5"
              src="https://www.youtube.com/embed/A9k1BvOGahs?si=9aIRxK1yfxqV860D" 
              title="女声合唱とピアノのための小品集〈ポケットの星〉より 「麦わら帽子」  (作曲: 沼尻竜典)r"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
          </div>
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/Top/Top.jsx